import { connect } from 'react-redux'
import DeleteUserGroupView from './DeleteUserGroupView.jsx';
import { deleteUserGroup } from 'src/legacy/redux/actions/userGroups';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';


const mapStateToProps = (state, ownProps) => {
  var id = ownProps.id;
  var userGroup = state.legacyRootReducer.settings.userGroup.userGroup[id];

  return {
    userGroups: state.legacyRootReducer.settings.userGroup.items,
    userGroup: userGroup && userGroup.item ? userGroup.item : null,
    deleting: userGroup ? userGroup.deleting : false,
    user: state.users.me
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteUserGroup: (id) => {
      return dispatch(deleteUserGroup(id));
    }
  }
}

const DeleteUserGroupContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteUserGroupView)

export default withUseHooks(DeleteUserGroupContainer);